module.exports = __webpack_public_path__ + "img/frame_degree_m_4.033352e3.png";